<template>
    <div>
        存量房更多界面
    </div>
</template>

<script>
    export default {
        name: "clf_showmore"
    }
</script>

<style scoped>

</style>